import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/share.svg'


const _withScopeId = n => (_pushScopeId("data-v-d97fd3d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + '#shape'
const _hoisted_2 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-12 col-md-8 col-lg-6 col-xl-5 col-xxl-4" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { id: "shareIconWrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { href: _hoisted_1 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { id: "fader" }
const _hoisted_12 = { id: "download-app-area" }
const _hoisted_13 = { id: "download-app-header" }
const _hoisted_14 = { id: "download-app-button-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_media_component = _resolveComponent("item-media-component")!
  const _component_item_user_info_component = _resolveComponent("item-user-info-component")!
  const _component_item_info_component = _resolveComponent("item-info-component")!
  const _component_item_comments_component = _resolveComponent("item-comments-component")!
  const _component_share_alert = _resolveComponent("share-alert")!
  const _component_not_found_component = _resolveComponent("not-found-component")!

  return (_ctx.item != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_ctx.item.item != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_item_media_component, {
                      id: "item-media",
                      style: _normalizeStyle(_ctx.mediaSize),
                      itemURL: _ctx.item.item.url,
                      mediaType: _ctx.item.item.type
                    }, null, 8, ["style", "itemURL", "mediaType"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_item_user_info_component, {
                        id: "userInfo",
                        username: _ctx.item.item.username,
                        itemUserAvatarUrl: _ctx.item.item.userAvatarUrl,
                        createdAt: _ctx.item.item.created,
                        userLevel: _ctx.item.item.userLevel
                      }, null, 8, ["username", "itemUserAvatarUrl", "createdAt", "userLevel"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(), _createElementBlock("svg", {
                        id: "shareIcon",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showShareAlert && _ctx.showShareAlert(...args)))
                      }, _hoisted_10))
                    ])
                  ]),
                  _createVNode(_component_item_info_component, {
                    title: _ctx.item.item.title,
                    downloads: _ctx.item.item.downloads,
                    shares: _ctx.item.item.shares,
                    views: _ctx.item.item.views,
                    upvotes: _ctx.item.item.upvotes,
                    downvotes: _ctx.item.item.downvotes,
                    tags: _ctx.item.item.tags
                  }, null, 8, ["title", "downloads", "shares", "views", "upvotes", "downvotes", "tags"]),
                  _createVNode(_component_item_comments_component, {
                    commentCount: _ctx.item.item.totalComments,
                    comments: _ctx.item.comments
                  }, null, 8, ["commentCount", "comments"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.t('see-more')), 1),
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openApp && _ctx.openApp(...args))),
                    id: "download-app-button"
                  }, [
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.t('download-app')), 1)
                  ])
                ])
              ]),
              _createVNode(_component_share_alert, {
                isHidden: !_ctx.shareAlertShown,
                link: _ctx.shareLink,
                "onShare:closeAlert": _ctx.hideShareAlert
              }, null, 8, ["isHidden", "link", "onShare:closeAlert"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.item.loadingState == _ctx.LoadingState.Failed)
          ? (_openBlock(), _createBlock(_component_not_found_component, {
              key: 1,
              "onNotfound:retry": _ctx.reloadItem
            }, null, 8, ["onNotfound:retry"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}